module.exports = __webpack_public_path__ + "static/img/pico33.8b449a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pico33.png
// module id = XC48
// module chunks = 0